<div class="container-login">
  <div class="login-wrapper">
    <div class="login-card">
      <div class="logo">
        <img src="../../../../assets/svg/logo.svg" alt="Logo" />
      </div>
      <div class="header">
        <h3 class="welcome">{{'global.welcome' | translate}}</h3>
        <p>{{ 'global.selectCustomerMessage' | translate }}</p>
      </div>
      <form [formGroup]="form" class="flex flex-col gap-4">
        <flow-form-select
          label="{{'global.customer' | translate}}"
          placeholder="{{'global.customer' | translate}}"
          formControlName="customerId"
          [options]="customers"
          [multiple]="false"
          [required]="true"
          [selectAll]="false"
        />

        <flow-button theme="primary" variation="fill" type="button" [fullWidth]="true" [disabled]="loadingLogin" (onClick)="selectCustomer()">Proceed</flow-button>
        <flow-button theme="secondary" variation="outline" type="button" [fullWidth]="true" [routerLink]="['/login', { hasMultipleCustomers: true }]">Back</flow-button>
      </form>
    </div>
    <div>
      <p>© BizLab Analytics {{currentYear}}</p>
    </div>
  </div>
  <div class="image-wrapper"></div>
</div>
